import AdAnnotations from '../react/annotations/AdAnnotations'
import ResolvedAnnotationsHandler from '../components/ResolvedAnnotationsHandler'

export default class AdDesignJobsAnnotations {
  constructor(params) {
    this.params = params;
  }

  unload() {
    AdAnnotations.unload()
  }

  index() {
    // unload here in event user pushed back in browser
    AdAnnotations.unload()
    if ($('img.js-annotation-boundry').length) {
      let img = new Image()
      img.src = $('img.js-annotation-boundry')[0].src
      img.onload = () => {
        this.adAnnotations = AdAnnotations.init();
        this.setupResolvedHandler()
      }
    } else {
      this.adAnnotations = AdAnnotations.init();
      this.setupResolvedHandler()
    }
  }

  setupResolvedHandler(){
    let currAnno = $.grep(this.adAnnotations.annotations, (anno) => { return anno.id == this.params.currentAnnotation; })[0] || {};
    // has to come after annotations init
    new ResolvedAnnotationsHandler({resolved: currAnno.resolved})
  }
}
